import { useToggle } from "hooks/useToggle";
import Tree from "ds/components/Tree";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import HistoryEntryLabel from "components/Run/elements/HistoryEntryLabel";
import { RunDependency } from "types/generated";
import { pluralize } from "shared/Pluralize";

import { RunHistoryEntryType } from "../../types";
import DependenciesEntryRunDependency from "../DependenciesEntry/RunDependency";

type TriggeredRunsEntryProps = {
  triggeredRuns: RunDependency[];
  timestamp: number;
};

const TriggeredRunsEntry = ({ triggeredRuns, timestamp }: TriggeredRunsEntryProps) => {
  const [isExpanded, toggle] = useToggle(true);

  const count = triggeredRuns.length;

  const label = (
    <HistoryEntryLabel>
      <strong>Triggered</strong> {count} dependent {pluralize("run", count)}
    </HistoryEntryLabel>
  );

  return (
    <HistoryEntryWrapper
      label={label}
      timestamp={timestamp}
      state={RunHistoryEntryType.TriggeredRuns}
      isOpen={isExpanded}
      onClick={() => toggle()}
      terminal
    >
      {isExpanded && (
        <Tree padding="0 0 0 large">
          {triggeredRuns.map((item) => (
            <DependenciesEntryRunDependency key={item.id} item={item} />
          ))}
        </Tree>
      )}
    </HistoryEntryWrapper>
  );
};

export default TriggeredRunsEntry;